// Cart drawer 

function changeQty(a,b){ 
  var data = {
    quantity: b,
    id: a
  }
  jQuery.ajax({
    type: 'post',
    url: '/cart/change.js',
    data: data,
    success: function(d){
    
      refreshCart()
    },

    dataType: 'json'
  });
}

function refreshCart(){
  jQuery.getJSON('/cart.js', function(cart) {

   var credit_only = $('#outlet-product').val();
   var outlet_flag = false;
   var archive_flag = false;
   $('.cartCountDetails').html(''); 
   $('.cartCountDetails').text('('+cart.item_count+')');
    
    if(cart.item_count == 0){
    	$('.cart-content').addClass('data-not');
    }else{
    	$('.cart-content').removeClass('data-not');
    }
    
    var infoHTML = "";
    var cartHTML = "";
    $.each(cart.items, function(listItem, item) {
      infoHTML += "<div class='image-left' data-item-id="+item.id+">";
      infoHTML += "<div class='productImage'><a href="+item.url+" class='p-0'><img src="+item.featured_image.url+"></a></div>";
      infoHTML += "<div class='right-side'>";
      
      infoHTML += "<div>";
      infoHTML += "<div class='prd-title'>";
      infoHTML += "<a href="+item.url+" class='p-0 text-black'>";
      infoHTML += "<p class='fs-12 font-weight-bold text-uppercase'>" + item.product_title + "</p>";
      infoHTML += "</a>";
      infoHTML += "</div>";
      $.each(item.options_with_values, function(listItems, lineitem) {
        if(lineitem.value != 'Default Title'){
          infoHTML += "<div class='variants text-uppercase'>"+ lineitem.name + ':'+ lineitem.value +"</div>";
        }
      })
      if(item.properties) {
        $.each(item.properties, function(title, value) {
          if (value && value !='outlet') {
            infoHTML += "<div class='variants text-uppercase'>"+ title + ':'+ value +"</div>";
          }else{
            outlet_flag = true;
          }
        });
      }
       if(item.properties) {
        $.each(item.properties, function(title, value) {
          console.log(value);
          if (value && value !='archive') {
            infoHTML += "<div class='variants text-uppercase'>"+ title + ':'+ value +"</div>";
          }else{
            archive_flag = true;
          }
        });
      }
       
      infoHTML += "</div>";
      infoHTML += "<div class='plus-minus'>";
      infoHTML += "<button class='minusBtn btn fs-12'>-</button>";
      infoHTML += "<input class='fs-12 text-uppercase' value="+ item.quantity +" data-variant-id="+ item.variant_id +" readonly>";
      infoHTML += "<button class='plusBtn btn fs-12'>+</button>";
      infoHTML += "</div>";
      infoHTML += "</div>";
      infoHTML += "<div class='price-sec'>";
      infoHTML += "<p class='fs-12 text-end'>" + Shopify.formatMoney(item.original_line_price).replace('$','£') + "</p>";
      infoHTML += "<button data-variant-id = "+item.variant_id+" class='removeProduct btn p-0 fs-10 text-end text-uppercase text-nowrap'>Remove</button>";
      infoHTML += "</div>";

      infoHTML += "</div>";
      infoHTML += "</div>";
    });
    $('.cart-content').html(infoHTML);
    // Additional content
    console.log(cart.item_count);
      // if (credit_only === "outlet") {
      //   cartHTML += "<div class='returns-info'>";
      //   cartHTML += "<p class='fs-12'>Please note: returns for OUTLET items are eligible for store credit only.</p>";
      //   cartHTML += "</div>";
      // }
      if(outlet_flag){
        cartHTML += "<div class='returns-info'>";
        cartHTML += "<p class='outlate-cart-note'>Please note: returns for <b>OUTLET</b> items are eligible for store credit only.</p>";
        cartHTML += "</div>";
      }
       if(archive_flag){
        cartHTML += "<div class='returns-info archive'>";
        cartHTML += "<p class='outlate-cart-note'>Please note: returns for <b>ARCHIVE</b> items are eligible for store credit only.</p>";
        cartHTML += "</div>";
      }
      cartHTML += "<div class='cart-total'>";
      cartHTML += "<div class='d-flex justify-content-between subtotal-drawer pt-3'>";
      cartHTML += "<div class='total'>Total</div>";
      cartHTML += "<div class='total'>"+Shopify.formatMoney(cart.original_total_price).replace('$','£')+"</div>";
      cartHTML += "</div>";
      cartHTML += "<a class='checkout-btn btn fs-12 text-uppercase w-100' href='/checkout'>Proceed to Checkout</a>";
      cartHTML += "<a class='drawer-veiwbag btn fs-12 text-uppercase w-100' href='/cart'>View Bag</a>";
  //     cartHTML += "<div>";
  //     cartHTML += "<a href='javascript:void(0)' class='continue-link boda-underline-effect text-uppercase btn fs-12'>Continue Shopping</a>";
  //     cartHTML += "</div>";
      cartHTML += "</div>";
    $('.cart-content').append(cartHTML);

  });
}


$(document).ready(function(){ 
  $drawerRight = $('.cart-drawer-right');
  $cart_list = $('.cart-btn, .close-btn');	
  $cart_list.click(function() {
    $(this).toggleClass('active');
    $('.cart-drawer-push').toggleClass('cart-drawer-pushtoleft');
    $drawerRight.toggleClass('cart-drawer-open');
  });
  $('.cart-btn').click(function(){
    refreshCart();      
  });
  $(document).on("click",".plusBtn",function() {
    var itemvariantId = $(this).closest('.plus-minus').find('input').attr('data-variant-id');
    var itemQuantity = $(this).closest('.plus-minus').find('input').val();
    var newQuantity = parseInt(itemQuantity) + 1;
    $(this).closest('.plus-minus').find('input').val(newQuantity)
    itemvariantId = itemvariantId.replace(/\"/g, "");
    changeQty(itemvariantId,newQuantity);

  });
  $(document).on("click",".minusBtn",function() {
    var itemvariantId = $(this).closest('.plus-minus').find('input').attr('data-variant-id');
    var itemQuantity = $(this).closest('.plus-minus').find('input').val();
    var newQuantity = parseInt(itemQuantity) - 1;
    $(this).closest('.plus-minus').find('input').val(newQuantity)
    itemvariantId = itemvariantId.replace(/\"/g, "");
    changeQty(itemvariantId,newQuantity);
  });

  $(document).on("click",".removeProduct",function() {
    var itemvariantId = $(this).attr('data-variant-id');
    var itemQuantity = 0;
    itemvariantId = itemvariantId.replace(/\"/g, "");
    changeQty(itemvariantId,itemQuantity);
  });


  // When normal product add to cart    	
  $('.product-form__buttons .product-form__submit').click(function (e) {
    e.preventDefault();
    console.log(222,$('#product-form-installment').serialize())
    $('.error-message-pdp').remove();
    $('.product-form__buttons .product-form__submit span').addClass('hidden');
    $('.product-form__buttons .product-form__submit .loading-overlay__spinner').removeClass('hidden');
    $.ajax({
      type: 'POST',                             
      url: '/cart/add.js',
      dataType: 'json',                               
      data: $('#product-form-installment').serialize(),            
      success: function(response){
        // $.ajax({
        //   type: 'POST',
        //   url: '/cart.js',
        //   dataType: 'json',
        //   success: function(cartdata){
            refreshCart();
            $('.product-form__buttons .product-form__submit span').removeClass('hidden');
            $('.product-form__buttons .product-form__submit .loading-overlay__spinner').addClass('hidden');
            $('.cartNav').addClass("cart-open");
            $('body').addClass('cart-drawer-open');

        //   }
        // });         
      },                        
      error: function(data){
        $('.product-form__buttons').before('<p class="error-message-pdp text-danger">'+data.responseJSON.description+'</p>');
        $('.product-form__buttons .product-form__submit span').removeClass('hidden');
        $('.product-form__buttons .product-form__submit .loading-overlay__spinner').addClass('hidden');
      }                           
    });
  })

  // When Related product add to cart
  $('.you-may-also-like .RelatedAddToCart').click(function (e) {
    e.preventDefault();
    console.log(333);
    var data = $(this).closest('form').find('input:checked').attr('value');
    let formData = {
      'items': [{
        'id': data,
        'quantity': 1
      }]
    };

    $.ajax({
      type: 'POST',                             
      url: '/cart/add.js',
      dataType: 'json',                               
      data: formData,            
      success: function(response){
        $.ajax({
          type: 'POST',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            refreshCart();
            $('.cartNav').addClass("cart-open");
            $('body').addClass('cart-drawer-open');
          }
        });         
      },                        
      error: function(data){
        alert(data.responseJSON.description);
      }                           
    });
  })
  
   
  // Personalize product add to cart  
  
  $('.add-to-cart-personalize').click(function(e){
    e.preventDefault(); 
    if($('#personalize').val().length > 0){
      $('#personalize').removeClass('error');
      var data = $('#personalize').attr('data-id');
      let formData = {
        'items': [{
          'id': data,
          'quantity': 1,
          'properties': {
            'PERSONALIZE': $('#personalize').val()
          }
        }]
      };
      $.ajax({
        type: 'POST',                             
        url: '/cart/add.js',
        dataType: 'json',                               
        data: formData,            
        success: function(response){
          $.ajax({
            type: 'POST',
            url: '/cart.js',
            dataType: 'json',
            success: function(cartdata){
              refreshCart();
              $('.cartNav').addClass("cart-open");
              $('body').addClass('cart-drawer-open');
            }
          });         
        },                        
        error: function(data){
          alert('Something went wrong! Please refresh the page and try again');
        }                           
      });
      
    }else{
      $('#personalize').addClass('error');
    }
  })
  
  
  // Extras product Add to cart Functionality. 
  
  $('.add-extra-btn').click(function(){
    
    var isValid = true;
    if ($('.engraving-div [type="checkbox"]').prop('checked')==true){ 
      if($('#prop_name').val().length > 9){
      	$('#prop_name').removeClass('error');
        isValid = true;
      }else{
      	$('#prop_name').addClass('error');
        isValid = false;
      }
    }
    
    if(isValid == true){
      var queryArr = [];
    $('.extra-size-new li').each(function(){
      if($(this).find('[type="checkbox"]').prop('checked')==true){
        
        
        if($(this).find('.desc').attr('data-title') == 'Engraving'){
          var data = $(this).find('.desc').attr('data-id');
          var enText = $('#prop_name').val().toUpperCase();
          var items =  {
            'id': data,
            'quantity': 1,
              'properties': {
                'ENGRAVING': enText
              }
          }
         queryArr.push(items);
        }else{
        
        var data = $(this).find('.desc').attr('data-id');
          var items =  {
            'id': data,
            'quantity': 1
          }
         queryArr.push(items);
        
        }
        
        
       
      }else{
      	
      }
    })
    
  JSON.stringify(queryArr)  
  let formData = {
    'items': queryArr
  };

      $.ajax({
      type: 'POST',                             
      url: '/cart/add.js',
      dataType: 'json',                               
      data: formData,            
      success: function(response){
        refreshCart();
        $('.cartNav').addClass("cart-open");
        $('body').addClass('cart-drawer-open');
      },                        
      error: function(data){
        alert('Something went wrong! Please refresh the page and try again');
      }                           
    });
      
    }
  })

})


$('.cartbag').click(function(){
  refreshCart();
  if($(window).width() > 1024){
    $('.cartNav').addClass("cart-open");
    $('body').addClass('cart-drawer-open');
  }else{
    $('.cartNav').addClass("cart-open");
     $('body').addClass('cart-drawer-open');
  }
})

// Cart Drawer Close 

$('.cartDrawerClose').click(function(){
  $('.cartNav').removeClass('cart-open');
  $('body').removeClass('cart-drawer-open');
})